import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'requestduration'
})
export class RequestdurationPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value == "1") {
      return "/day";
    }
    if (value == "2") {
      return "/month";
    }
    if (value == "3") {
      return "/year";
    }
    if (value == "4") {
      return "/week";
    } 
  }

}
